let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';

/**
 * Studio dot background canvas based on automation-ui-canvas.
 *
 * @see https://git.hubteam.com/HubSpot/automation-ui-canvas/blob/0a22f4315a1653c7396e8355f0be897892f5705d/automation-ui-canvas/static/js/containers/FlowCanvasBase.tsx#L79-L89
 */
const CanvasContainer = styledWithTheme.div(_t || (_t = _`
  position: relative;
  padding-block-start: ${0};
  padding-block-end: ${0};
  padding-inline: ${0};
  border: 1px solid ${0};
  border-radius: ${0};
  margin-block-end: ${0};
  background-color: ${0};
  background-image: radial-gradient(
    circle at 1px 1px,
    ${0} 1px,
    transparent 0
  );
  background-size: 20px 20px;
`), ({
  theme: {
    space
  }
}) => space['600'], ({
  theme: {
    space
  }
}) => space['800'], ({
  theme: {
    space
  }
}) => space['600'], ({
  theme: {
    color
  }
}) => color['border-core-subtle'], ({
  theme: {
    borderRadius
  }
}) => borderRadius['400'], ({
  theme: {
    space
  }
}) => space['600'], ({
  theme: {
    color
  }
}) => color['fill-surface-recessed'], ({
  theme: {
    color
  }
}) => color['fill-surface-recessed-pressed']);
export default CanvasContainer;